const ADD_SECTION = "faq/duck/ADD_SECTION";
const ADD_ENTRY = "faq/duck/ADD_ENTRY";
const ADD_SECTION_ENTRY_REF = "faq/duck/ADD_SECTION_ENTRY_REF";

export default {
  ADD_SECTION,
  ADD_ENTRY,
  ADD_SECTION_ENTRY_REF
};